<template>
  <div class="register-second-step d-flex flex-column align-center">
    <LocationSelector
      verticalLayout
      key="access-account-location"
      :organizationId="organizationId"
      :location="location"
      @change="onLocationChange"
    />

    <div class="mt-4">
      <Checkbox
        id="send_me_email_notifications"
        testId="createAccount-checkbox-notifications"
        :name="$t('auth.register.send_me_email_notifications')"
        @onChecked="onSendEmailNotificationsChecked"
      />
    </div>

    <Button
      class="mt-6"
      block
      color="primary"
      data-testid="createAccount-button-continue"
      :disabled="isButtonDisabled"
      :text="submitText"
      @click="onSubmit"
    />
  </div>
</template>

<script>
import LocationSelector from '@/components/LocationSelector/LocationSelector.vue'
import Checkbox from '@/components/Core/Checkbox.vue'
import Button from '@/components/UI/Button'

export default {
  name: 'AccessLocationView',

  props: {
    organizationId: {
      type: String,
      required: false,
    },
    location: {
      type: Object,
      required: true,
    },
    submitText: {
      type: String,
      required: true,
    },
    isButtonDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  components: {
    Checkbox,
    LocationSelector,
    Button,
  },

  data() {
    return {
      checkboxes: {
        send_me_email_notifications: false,
      },
    }
  },

  methods: {
    onSubmit() {
      this.$emit('onSubmit')
    },

    onLocationChange(location) {
      this.$emit('onLocationChange', location)
    },

    onSendEmailNotificationsChecked(name, value) {
      this.checkboxes[name] = value
      this.$emit('onCheckboxChecked', this.checkboxes)
    },
  },
}
</script>
<style lang="scss">
.register-second-step {
  #uber-widget #tags-browser {
    margin-top: 24px;
    margin-bottom: 16px;
  }
}
</style>
